
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class AttachedDocument extends Vue {
    @Prop({ type: String, required: true }) readonly name!: string;
  }
